import React, { useEffect, useState } from "react";
import styles from "./row.module.sass";
import Control from "./Control/index";
import { Link, useParams } from "react-router-dom";
import Store from '../../../../../../media/images/placeholders/Store.png'
import CurrencyTooltip from '../../../../../CustomTooltips/CurrencyTooltip'
import TooltipGlodal from "../../../../../TooltipGlodal";
import ToolTip from '../../../../../CustomTooltips/ReusableTooltip'
import cn from "classnames";
import { extarctImageFromUrlAction } from "../../../../../../redux/action/common/commonAction";
import { useDispatch } from "react-redux";

const Row = ({ item, className, locationOption, access, isLast, value, onChange }) => {
    
    const {appid} = useParams()
    const dispatch = useDispatch()

    const extractImageFromCdn = async(url, id) => {
        if(url !== null && url !== undefined && url.includes('cdn')){
            try {
                const response = await dispatch(extarctImageFromUrlAction(url))
                const logo = document.getElementById(`storeIcon_${id}`)
                if(logo){
                    logo.src = response
                }
            }catch (error){
                console.error('Error fetching image:', error);
            }
        }else{
            const logo = document.getElementById(`storeIcon_${id}`)
            if(logo){
                logo.src = Store
            }
        }
    }

    useEffect(() => {
        extractImageFromCdn(item.iconUrl, item.id)
    }, [item])

    return (
        <>
            <div className={styles.row}>
                <div className={styles.col}>
                    <div className={styles.item}>
                        {item.iconUrl !== undefined ?
                            <div className={cn(styles.preview, className, {[styles.bg] : true})}>
                                <img id={`storeIcon_${item.id}`} alt="Store" />
                            </div>
                            :
                            <div className={styles.preview}></div>
                        }
                        <div className={styles.details}>
                            <div>{item.name}</div>
                            <div className={styles.itemId}>{item.storeId}</div>
                        </div>
                    </div>
                </div>
                <div className={styles.col}>
                    <Link to={`/view-store/${appid}/${item.id}`}>
                        <TooltipGlodal width={180} itemId={`store${item.id}`} title={item.name}><div className={styles.itemName}><span id={`store${item.id}`}>{item.name}</span></div></TooltipGlodal>
                        <div className={styles.itemId}>{item.storeId}</div>
                    </Link>
                </div>
                <div className={styles.col}>
                    {item.storesCategories && item.storesCategories.slice(0,1).map((e,i)=>{
                        return (
                            <>
                            <div className={styles.prices}>
                                <span className={i%2==0 ? styles.virtual : styles.IAP}>{e.name}</span>
                                {(item.storesCategories && item.storesCategories.length > 1) ? 
                                    <CurrencyTooltip type='Stores'  isLast={isLast} text='Categories
                                    ' data={item.storesCategories}><span className={styles.count}>+ {item.storesCategories.length - 1}</span></CurrencyTooltip>  
                                : ''}
                            </div>
                            </>
                        )
                    })}
                </div>
                <div className={styles.col}>
                    {item.storeLocations && item.storeLocations.slice(0,1).map((e,i)=>{
                        return (
                            <>
                                {(item.storeLocations && item.storeLocations.length ===locationOption?.length) ? <span>Global</span>:<span>{e.storeLocationMaster.name}</span>}
                                {(item.storeLocations && item.storeLocations.length > 1) ?
                                    (item.storeLocations && item.storeLocations.length ===locationOption?.length) ?"":
                                    <ToolTip text='Locations' data={item.storeLocations.map(item => item.storeLocationMaster)} isLast={isLast}><span className={styles.count}>+ {item.storeLocations.length - 1}</span></ToolTip>  
                                :''}
                            </>
                        )
                    })}
                </div>
                <div className={styles.col}>
                    {item.storePlatforms && item.storePlatforms.slice(0,1).map((e,i)=>{
                        return (
                            <>
                                <span>{e?.storePlatformMaster?.name!== 'ios' ? e?.storePlatformMaster?.name.charAt(0).toUpperCase() + e?.storePlatformMaster?.name.slice(1) : e?.storePlatformMaster?.name === 'ios' ? 'iOS' : ''}</span>
                                {(item.storePlatforms && item.storePlatforms.length > 1) ? 
                                    <ToolTip text='Platforms' data={item.storePlatforms && item.storePlatforms.map(item => {
                                        const updatedItem = { ...item };  // Copy the current object to avoid mutating the original
                                        console.log(updatedItem)
                                        if (updatedItem?.storePlatformMaster?.name !== 'ios' && updatedItem?.storePlatformMaster?.name !== 'Ios') {
                                          updatedItem.storePlatformMaster.name = updatedItem.storePlatformMaster.name.charAt(0).toUpperCase() + updatedItem.storePlatformMaster.name.slice(1);
                                        }else{
                                            updatedItem.storePlatformMaster.name = 'iOS'
                                        }
                                        return updatedItem.storePlatformMaster;  // Return only the storePlatformMaster part
                                      })}  isLast={isLast}><span className={styles.count}>+ {item.storePlatforms.length - 1}</span></ToolTip>  
                                : ''}
                            </>
                        )
                    })}
                </div>
                <div className={styles.col}>
                    {Object.keys(item).length !== 0 &&
                        <Control access={access} className={styles.control} appid={appid} id={item.id} name={item.name} status={item.archive} type='stores' />
                    }
                </div>
            </div>
        </>
    );
};

export default Row;
